import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Growth = (props: IIcon) => {
  const { className = '', ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-8 h-8', className)}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.68945 21.5634V30.4914C6.68945 30.7474 6.47201 30.9714 6.22351 30.9714H2.46498C2.21648 30.9714 1.99905 30.7474 1.99905 30.4914V21.3714C1.99905 21.0834 2.24754 20.8594 2.5271 20.8914C3.45897 21.0194 4.39084 21.0834 5.38483 21.0834H6.22351C6.47201 21.0834 6.68945 21.3074 6.68945 21.5634ZM14.0512 20.3154V30.5234C14.0512 30.7794 13.8338 31.0034 13.5853 31.0034H9.82674C9.57824 31.0034 9.3608 30.7794 9.3608 30.5234V21.2114C9.3608 20.9874 9.51612 20.7634 9.76461 20.7314C10.976 20.5074 12.2185 20.2194 13.461 19.8354C13.7406 19.7394 14.0512 19.9634 14.0512 20.3154ZM21.5683 16.9554V30.4914C21.5683 30.7474 21.3508 30.9714 21.1023 30.9714H17.3749C17.1264 30.9714 16.9089 30.7474 16.9089 30.4914V18.9394C16.9089 18.7474 17.0332 18.5874 17.1885 18.4914C17.3749 18.3954 17.5612 18.3314 17.7476 18.2354C18.8348 17.7234 19.8909 17.1474 20.8849 16.5394C21.1955 16.3474 21.5683 16.6034 21.5683 16.9554ZM29.0543 10.8114V30.4914C29.0543 30.7474 28.8368 30.9714 28.5883 30.9714H24.8298C24.5813 30.9714 24.3639 30.7474 24.3639 30.4914V14.5554C24.3639 14.3954 24.426 14.2674 24.5503 14.1714C25.917 13.0514 27.1595 11.8034 28.2467 10.4914C28.5262 10.1714 29.0543 10.3634 29.0543 10.8114Z"
        fill="#2A96FF"
      />
      <path
        d="M30.5177 2.07517V8.53917C30.5177 9.14717 29.8654 9.49917 29.3995 9.17917L27.66 7.99517C25.0197 11.5792 21.2301 14.6512 16.6639 16.7952C12.719 18.6512 8.55668 19.6432 4.79815 19.6432C3.71097 19.6432 2.65485 19.5472 1.62979 19.3872C1.41236 19.3552 1.28811 19.1632 1.28811 18.9392V16.8592C1.28811 16.5712 1.53661 16.3792 1.7851 16.4432C5.8232 17.1792 10.7932 16.3472 15.5146 14.1392C19.5217 12.2512 22.9385 9.49917 25.2682 6.36317L23.2802 5.01917C22.7832 4.66717 22.8764 3.89917 23.4355 3.70717L29.5548 1.40317C30.0207 1.17917 30.5177 1.56317 30.5177 2.07517Z"
        fill="#2A96FF"
      />
    </svg>
  );
};

export default Growth;
